import { TableColumn } from 'modules/shared-components/data-display/table/types';
import { Pagination } from 'api/types/httpsTypes';
import AssetIcon from 'modules/shared-components/asset/asset-icon';
import { formatTokenAmountCompact } from 'utils/FormatNumber';
import Big from 'big.js';
import { MonthlyStats } from 'api/types/httpsTypes/marketplace-performance';

export type DistributionTableData =
  (MonthlyStats['tradesDistribution']['others'] &
    Partial<
      Omit<
        MonthlyStats['tradesDistribution']['chart'][number],
        'fraction' | 'hits' | 'avgReturns'
      >
    >)[];

export type ColumnProps = {
  pagination: Pagination;
  data: DistributionTableData;
  errors?: any[];
};

export const hitsDistributionColumn: TableColumn<
  ColumnProps['data'][number]
>[] = [
  {
    label: (
      <>
        <span className="hidden lg:block">Pair / % of Vol</span>
        <span className="lg:hidden">Pair</span>
      </>
    ),
    key: 'pairAsPercentageOfVolume',
    component: ({ data }) => (
      <div className="flex items-center justify-between ">
        {data.base ? (
          <div className="flex space-x-2">
            <AssetIcon imgName={data.base} />
            <div>
              {data.base}/{data.quote}
            </div>
          </div>
        ) : (
          'Others'
        )}
        <div className="bg-white-400 dark:bg-black-600 xxs:rounded-sm xxs:py-1 xxs:px-2">
          {Big(data.fraction || '0')
            .mul(100)
            .toFixed(1)}
          %
        </div>
      </div>
    ),
  },
  {
    label: <>Hits</>,
    key: 'hits',
    component: ({ data }) => (
      <div className="flex items-center justify-between space-x-2 ">
        {formatTokenAmountCompact(data.hits || 0)}
      </div>
    ),
  },
  {
    label: <>Returns</>,
    key: 'PnLOverCapital',
    component: ({ data }) => (
      <span
        className={
          parseFloat(data?.avgReturns || '0') > 0
            ? 'text-green-success'
            : 'text-red-warning'
        }
      >
        {parseFloat(data?.avgReturns || '0') > 0 && '+'}
        {Big(data?.avgReturns || 0)
          .mul(100)
          .toFixed(2)}
        %
      </span>
    ),
  },
];
